export default __webpack_public_path__ + "refresh.a2df6dd5.svg";